<template>
    <div class="float-left">
        <b-button-group class="float-right">
            <b-button
                variant="success" @click="abrirModal()" v-if="$temAcessoView('CONV-00') && parentData.idSituacaoConvenio != 9 && modoCadastro">
                    Adicionar
            </b-button>
        </b-button-group>

        <i
            class="fa fa-pencil-square fa-lg icon-button"
            title="Alterar Documento"
            v-if="$temAcessoView('CONV-00') && parentData.idSituacaoConvenio != 9 && !modoCadastro" @click.stop="abrirModal()"
        ></i>

        <b-modal
            id="modalAdicionarCronograma"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop>
            <div slot="modal-title">
                Documento Prestação Contas -
                <b-badge variant="warning">{{ modo }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>

            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label for="idDocumento">Documento</label>
                        <b-input-group>
                            <b-form-select
                                type="text"
                                :options="combo"
                                value-field="idDocumento"
                                text-field="descricao"
                                v-model="idDocumento"
                                :disabled="!modoCadastro">
                            </b-form-select>
                            <b-form-invalid-feedback>
                                Documento é obrigatório
                            </b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label for="vcObservacoes">Observações</label>
                        <b-input-group>
                            <b-form-textarea
                                type="text"
                                rows="3"
                                v-model="vcObservacoes">
                            </b-form-textarea>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group v-if="idDocumento == 1 || idDocumento == 7 || idDocumento == 9 || idDocumento == 8 || idDocumento == 6">
                        <label>Arquivo</label>
                        <b-form-file
                            placeholder="Arquivo"
                            v-model="arquivo"
                            ref="arquivoInput"
                            :state="Boolean(arquivo)"
                            :disabled="!modoCadastro"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    :disabled="this.$v.$invalid"
                    @click.stop="salvar()"
                    class="ml-1">
                    Salvar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        parentData: Object,
        documento: Object,
        modoCadastro: Boolean
    },

    validations: {
        idDocumento: { required }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            combo: [],
            modo: '',
            idDocumento: null,
            idConvenio: null,
            vcObservacoes: null,
            arquivo: null,
            nomeArquivo: '',
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
            this.idDocumento = null
            this.idConvenio = null
            this.vcObservacoes = null
            this.arquivo = null
            this.modo = 'NOVO'

            if (!this.modoCadastro) {
                this.idDocumento = this.documento.idDocumento
                this.idConvenio = this.documento.idConvenio
                this.vcObservacoes = this.documento.vcObservacoes
                this.modo = 'EDITAR'
            }
            this.carregaCombo()
        },

        fecharModal() {
            this.mostrarModal = false
        },

        carregaCombo() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ListarDocumentoPrestacaoContas().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.combo = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        salvar() {
            if (this.modoCadastro) {
                if(this.arquivo == null){
                    var objetoDto = {
                    idConvenio : this.$route.params.convenioId,
                    idDocumento : this.idDocumento,
                    vcObservacoes : this.vcObservacoes,
                    }
                } else {
                    var objetoDto = {
                    idConvenio : this.$route.params.convenioId,
                    idDocumento : this.idDocumento,
                    vcObservacoes : this.vcObservacoes,
                    arquivo : this.arquivo,
                    vcNomeArquivo: this.arquivo.name
                    }
                }
                this.$store.dispatch('addRequest')
                ConveniosServicos.InserirDocumentoPrestacaoContasConvenio(objetoDto).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$emit('atualizarCadastro')
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else {
                var objetoDto = {
                    idConvenio : this.$route.params.convenioId,
                    idDocumento : this.idDocumento,
                    vcObservacoes : this.vcObservacoes,
                    vcNomeArquivo: this.documento.vcNomeArquivo
                }
                this.$store.dispatch('addRequest')
                ConveniosServicos.AlterarDocumentoPrestacaoContasConvenio(objetoDto).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$emit('atualizarCadastro')
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
            this.fecharModal()
        },
    },
}
</script>